import styled, { css } from 'styled-components';

type CheckProps = {
  label?: string;
  checked?: boolean;
};

// for display purposes (not form input)

const RequirementCheckMark = styled.span(
  ({ theme }) => css`
    position: absolute;
    top: 0;
    left: 0;
    height: 25px;
    width: 25px;
    border: ${theme.borders.form};
    transition: background-color 0.35s ease;

    &::before {
      content: '';
      position: absolute;
      display: none;
      left: 6.5px;
      top: 6px;
      width: 5px;
      height: 18px;
      border: solid white;
      border-width: 0 3px 0 0;
      -webkit-transform: rotate(-45deg);
      -ms-transform: rotate(-45deg);
      transform: rotate(-45deg);
    }

    &::after {
      content: '';
      position: absolute;
      display: none;
      left: 9px;
      top: 5px;
      width: 5px;
      height: 10px;
      border: solid white;
      border-width: 0 3px 3px 0;
      -webkit-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
    }

    &.checked {
      background-color: ${theme.colors.green};
      border: 0px;

      &::after {
        display: block;
      }
    }

    &.crossed {
      background-color: ${theme.colors.main.error};
      border: 0px;

      &::after {
        display: block;
        left: 6.5px;
        top: 2px;
        height: 18px;
        border-width: 0 3px 0 0;
      }

      &::before {
        display: block;
      }
    }
  `
);

const RequirementCheckLabel = styled.span`
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 15px;
`;

const RequirementCheck = ({ label, checked }: CheckProps) => {
  return (
    <RequirementCheckLabel>
      {label}
      {/* if undefined it's empty, if true a tick displays, if false a cross displays */}
      <RequirementCheckMark
        className={checked === undefined ? '' : checked ? 'checked' : 'crossed'}
      />
    </RequirementCheckLabel>
  );
};

export { RequirementCheck };
